/**
 * mtf-50sma-page.js
 *
 * MTF 50 SMA strategy — two timeframe SMAs must align in direction,
 * then price pulls back past the shorter-timeframe SMA.
 *
 *   Daily long:   Weekly SMA↑ + Daily SMA↑ + price < Daily SMA
 *   Daily short:  Weekly SMA↓ + Daily SMA↓ + price > Daily SMA
 *   4H long:      Daily SMA↑ + 4H SMA↑ + price < 4H SMA
 *   4H short:     Daily SMA↓ + 4H SMA↓ + price > 4H SMA
 */

import React from 'react';
import StrategySignalsPage from './strategy-signals-page';
import { fetchMtf50smaData } from '../services/server-api';

const TF_LABELS = { daily: 'Daily (W + D aligned)', fourHour: '4H (D + 4H aligned)' };

function slopeLabel(slope) {
  if (slope === 'up')   return '↑ rising';
  if (slope === 'down') return '↓ falling';
  return '→ flat';
}

function renderDetails(entry) {
  const isDaily = entry.weeklySlope != null; // daily tf has weeklySlope
  return (
    <>
      {isDaily ? (
        <>
          <div className="mtf-ind-row">
            <span className="mtf-ind-label">Weekly SMA</span>
            <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>{slopeLabel(entry.weeklySlope)}</span>
          </div>
          <div className="mtf-ind-row">
            <span className="mtf-ind-label">Daily SMA</span>
            <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>{slopeLabel(entry.dailySlope)}</span>
          </div>
        </>
      ) : (
        <>
          <div className="mtf-ind-row">
            <span className="mtf-ind-label">Daily SMA</span>
            <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>{slopeLabel(entry.dailySlope)}</span>
          </div>
          <div className="mtf-ind-row">
            <span className="mtf-ind-label">4H SMA</span>
            <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>{slopeLabel(entry.h4Slope)}</span>
          </div>
        </>
      )}
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">50 SMA level</span>
        <span className="mtf-ind-value zone">
          {entry.sma50 != null ? `$${entry.sma50.toLocaleString(undefined, { maximumFractionDigits: 4 })}` : '—'}
        </span>
      </div>
    </>
  );
}

function Mtf50smaPage() {
  return (
    <StrategySignalsPage
      config={{
        title:      'MTF 50 SMA',
        icon:       '📈',
        subtitle:   'Two timeframe 50 SMAs aligned in same direction · price pulls back past lower-timeframe SMA',
        fetchFn:    fetchMtf50smaData,
        timeframes: ['daily', 'fourHour'],
        tfLabels:   TF_LABELS,
        renderDetails,
      }}
    />
  );
}

export default Mtf50smaPage;
